import { render, staticRenderFns } from "./BasicExportDialog.vue?vue&type=template&id=2c8f9f06&"
import script from "./BasicExportDialog.vue?vue&type=script&lang=js&"
export * from "./BasicExportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports